import Section from "./Section";

export type {
  Props as SectionProps,
  SectionHeadingProps,
  Alignment,
  BackgroundColour,
  Curve,
  Spacing
} from "./Section";

export default Section;
